
import { ArquivoInscricao } from "./arquivoInscricao";

export class EditalArquivosInscricao {
    cargoCargaHoraria: string;
    numeroAnoEdital: string;
    envioArquivoLiberado: boolean;    
    arquivos: ArquivoInscricao[] = [];
}


// WEBPACK FOOTER //
// ./src/app/models/editalArquivosInscricao.ts